import { API_URL } from "env";

function getCustomerID(): number | null {
    const userData = localStorage.getItem('user');
    if (userData) {
        const user = JSON.parse(userData);
        return user.id || null;
    }
    return null;
}
interface DeliveryAddress {
    id: number;
    customer_id: number;
    name: string;
    phone: string;
    address: string;
    province: string;
    district: string;
    ward: string;
    is_default?: boolean;
    created_at: string;
    updated_at: string;
}

interface DeliveryAddressResponse {
    status: boolean;
    data: {
        total: number;
        current_page: number;
        items: DeliveryAddress[];
    };
    msg: string;
}

async function getCustomerDeliveriesAddressList(): Promise<DeliveryAddressResponse> {
    try {
        const customerID = getCustomerID();
        if (customerID === null) {
            throw new Error('Customer ID not found');
        }
        const response = await fetch(`${API_URL}/api/v1/fe/customer_deliveries?sort[]=created_at,desc&customer_id=${customerID}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to fetch customer deliveries:', error);
        throw error;
    }
}

interface DeliveryAddressData {
    name: string;
    phone: string;
    address: string;
    province: string;
    district: string;
    ward: string;
    is_default?: boolean;
}

async function addCustomerDeliveryAddress(addressData: DeliveryAddressData) {
    try {
        const customerID = getCustomerID();
        if (customerID === null) {
            throw new Error('Customer ID not found');
        }
        const body = new FormData();
        body.append('name', addressData.name);
        body.append('phone', addressData.phone);
        body.append('address', addressData.address);
        body.append('province', addressData.province);
        body.append('district', addressData.district);
        body.append('ward', addressData.ward);
        if (addressData.is_default !== undefined) {
            body.append('is_default', addressData.is_default ? '1' : '0');
        }
        const response = await fetch(`${API_URL}/api/v1/fe/customer_delivery`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
            body: body,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to add customer delivery address:', error);
        throw error;
    }
}

async function deleteCustomerDeliveryAddress(addressID: number) {
    {
        try {
            const customerID = getCustomerID();
            if (customerID === null) {
                throw new Error('Customer ID not found');
            }
            const response = await fetch(`${API_URL}/api/v1/fe/customer_delivery/${addressID}`, {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Failed to delete customer delivery address:', error);
            throw error;
        }
    }
}

async function updateCustomerDeliveryAddress(addressID: number, addressData: DeliveryAddressData) {
    try {
        const customerID = getCustomerID();
        if (customerID === null) {
            throw new Error('Customer ID not found');
        }
        const response = await fetch(`${API_URL}/api/v1/fe/customer_delivery/${addressID}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
            body: JSON.stringify(addressData),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to update customer delivery address:', error);
        throw error;
    }
}


export {
    getCustomerDeliveriesAddressList,
    addCustomerDeliveryAddress,
    deleteCustomerDeliveryAddress,
    updateCustomerDeliveryAddress,
};